const AdminMenu = [
  {
    name: "Credit Member",
    link: "/credit-user",
  },

  {
    name: "Manage Member",
    link: "/manage-members",
  },
  {
    name: "Transaction History",
    link: "/all-transactions",
  },
  {
    name: "Message History",
    link: "/global-message-history",
  },

  {
    name: "Load Voucher",
    link: "#",
  },

  {
    name: "Message Statistics",
    link: "/message-stats",
  },
  {
    name: "Manage API",
    link: "#",
  },
];

export default AdminMenu;
